module.exports = __webpack_public_path__ + "img/card-reload.3649ab29.svg";